/* Indicadores para los resumenes */
import { parseFloatNumber } from "../../features/core/utils"
import { farmingType, getFarmingNameByType } from "./helpers"
import { PerHumTooltip } from "./ranch"

/* Siembra */
export const areaTotal = {
    text: 'Área total',
    tooltip: 'Suma de las áreas de los polígonos de las chacras'
}

export const areaClasificada = {
    text: 'Área clasificada',
    tooltip: 'Cantidad de área ya clasificada en chacras.'
}

export const areaSinClasificar = {
    text: 'Área sin clasificar',
    tooltip: 'Área de avance de sembradoras pendientes de clasificar'
}

export const areaTrabajada = {
    text: 'Área trabajada',
    tooltip: 'Es la suma del área total (polígonos suavizados) de las chacras que fueron marcadas como cerradas'
}

export const areaTotalCerrada = {
    text: 'Área total cerrada',
    tooltip: 'Suma de los polígonos de las chacras que fueron marcadas como cerradas'
}

export const areaTotalResiembra = {
    text: 'Área total resiembra',
    tooltip: 'Suma de área suavizada clasificadas como resiembra'
}

export const avanceBruto = {
    text: 'Avance Bruto',
    tooltip: 'Área trabajada dentro de las chacras + Área sin clasificar'
}

/* Cosecha */
export const areaTotalCosecha = {
    text: 'Area total',
    tooltip: 'Suma de área de los polígonos de las chacras'
}

export const areaTotalTrabajadaCosecha = {
    text: 'Area total trabajada',
    tooltip: 'Suma del área de los polígonos de avance dentro de las chacras.'
}

export const rindeMedioPonderado = {
    text: 'Rinde medio ponderado',
    tooltip: ''
}

export const humedadMediaPonderada = {
    text: 'Humedad media ponderada',
    tooltip: ''
}

export const chacrasTotal = {
    text: 'Chacras total',
    tooltip: ''
}

export const chacrasCerradas = {
    text: 'Chacras cerradas',
    tooltip: ''
}
export const chacrasProceso = {
    text: 'Chacras proceso',
    tooltip: ''
}

export const porcentajeAvanceTotal = {
    text: '% Avance total',
    tooltip: ''
}

export const tooltipSaveFarmingVersion = (farmingType: farmingType) => {
    return `Guardar el Estado Actual de toda la ${getFarmingNameByType(farmingType)} (configuraciones, chacras, etc)`
}

export const getHarvestRanchInfoTooltipPerformanceHumidity = (
    info: PerHumTooltip
): string => {
    let { 
        telemetry_points,
        telemetry,
        telemetry_std,
        csv_points,
        csv,
        csv_std 
    } = info

    let tooltip = '';
    let noInfoText = 'No hay información adicional'
    tooltip += `<b>Telemetría: </b>`
    if(
        telemetry_points || 
        telemetry  ||
        telemetry_std
    ){
        tooltip += `<br>`;
        tooltip +=`
        Puntos: ${parseFloatNumber(telemetry_points)}<br>
        Mediana: ${parseFloatNumber(telemetry)}
        `
    }else{
        tooltip += `<br> ${noInfoText}`
    }

    tooltip += `<br><br><b>CSV: </b>`;

    if(
        csv_points || 
        csv  ||
        csv_std
    ){
        tooltip += `<br>`;
        tooltip +=`
        Puntos:  ${parseFloatNumber(csv_points)}<br>
        Mediana: ${parseFloatNumber(csv)}
        `
    }else{
        tooltip += `<br> ${noInfoText}`
    }
    return tooltip
}